import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SimulationService } from '../simulation.service';
import {Simulation} from "@helpers/types/models";

@Component({
	selector: 'app-simulation-delete-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SimulationDeleteDialogComponent {

	private readonly destroyRef = inject(DestroyRef);
	task!: Simulation;

	constructor(
		@Inject(DIALOG_DATA) readonly data: { task: Simulation, paging: Partial<any> },
		public readonly service: SimulationService,
		private readonly dialogRef: DialogRef<boolean>
	) {
		this.task = this.data.task;
	}

	confirm = (): void => {
		this.service.delete({ id: this.task.id })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.success ) {
					this.dialogRef.close(true);
				}
			});
	}

	close = (): void => {
		this.dialogRef.close(false);
	}
}
